import { Form, Formik } from "formik";
import { observable } from "mobx";
import { inject, observer } from "mobx-react";
import { fromPromise, IPromiseBasedObservable } from "mobx-utils";
import React, { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { compose } from "recompose";
import * as yup from "yup";

import { TextField } from "nvent-web/components/form/TextField";

import { PersonalProps, RegistrationFlow } from "../../stores/RegistrationFlow";
import { RequiredFieldLabel, SubmitButton } from "./common";

export interface PersonalFormInnerProps {
  registration: RegistrationFlow;
}

const validationSchema = yup.object({
  firstName: yup.string().required(),
  lastName: yup.string().required(),
  phoneNumber: yup
    .string()
    .required()
    .phoneNumber(),
});

export class PersonalFormInner extends Component<PersonalFormInnerProps> {
  @observable
  submitPromise?: IPromiseBasedObservable<void>;

  render() {
    const { registration } = this.props;
    const { firstName, lastName, phoneNumber } = registration;
    const initialValues: PersonalProps = { firstName, lastName, phoneNumber };
    const isSubmitting = this.submitPromise && this.submitPromise.state === "pending";

    return (
      <Formik initialValues={initialValues} onSubmit={this.submit} validationSchema={validationSchema}>
        {() => (
          <Form noValidate={true}>
            <TextField name="firstName" label={<FormattedMessage id="form.firstName" />} required />

            <TextField name="lastName" label={<FormattedMessage id="form.lastName" />} required />

            <TextField type="tel" name="phoneNumber" label={<FormattedMessage id="form.phoneNumber" />} required />

            <RequiredFieldLabel />
            <SubmitButton disabled={isSubmitting} loading={isSubmitting}>
              <FormattedMessage id="actions.next" />
            </SubmitButton>
          </Form>
        )}
      </Formik>
    );
  }

  private submit = (personal: PersonalProps) => {
    this.submitPromise = fromPromise(this.props.registration.personalSubmitted(personal));
  };
}

export const PersonalForm = compose<PersonalFormInnerProps, {}>(
  injectIntl,
  inject("registration"),
  observer
)(PersonalFormInner);

export default PersonalForm;
